export interface DividerProps {
  margin?: string
}
export default function Divider(props: DividerProps) {
  return <div style={{
    width:"100%",
    maxHeight:"1px",
    minHeight:"1px",
    backgroundColor:"var(--static-divider-standard)",
    margin: props.margin ? props.margin : "16px 0"
  }}></div>;
}
